import styled from 'styled-components'

export const IconPickerContainer = styled.div`
    position: relative;
    width: 318px;
    border: none;
    box-shadow: none;
`

export const IconPickerDropdown = styled.div`
    position: absolute;
    top: calc(100% + 1px);
    background: var(--gray-0);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    padding: 16px;
`

export const IconPickerGrid = styled.div<{ columns: number; rows: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns}, 40px);
    grid-template-rows: repeat(${({ rows }) => rows}, 40px);
    gap: 1px;
    width: 100%;

    .grid-item {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--gray-200);
        box-shadow: none;
        border: none;
        cursor: pointer;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        i {
            margin: 0;
            padding: 0;
            color: var(--gray-1000);
            font-size: 15px;
        }
    }
`

export const InputContainer = styled.div`
    &:not(.disabled) {
        .form-control,
        .control-label {
            cursor: pointer;
        }
    }

    label {
        margin-left: 0 !important;
    }

    i {
        padding: 8px 0;
        font-size: 15px;
    }
`
